<template>
  <footer class="footer">
    <div class="footer-wrapper">
      <ul>
        <li v-if="carId"><button @click="openModal">Kontakt</button></li>
        <li><a href="https://www.pkw.de/agb/">AGB</a></li>
        <li><a href="https://www.pkw.de/datenschutz/">Datenschutzerklärung</a></li>
        <li><a href="https://www.pkw.de/impressum/">Impressum</a></li>
      </ul>
    </div>
    <contact-modal v-if="carId" :car-id="carId" :is-open="showModal" @close="closeModal" />      
  </footer>
</template>

<script>
import ContactModal from '../modals/ContactModal';

export default {
  components: {
    ContactModal,
  },
  props: ['carId'],
  data() {
    return {
      showModal: false,
    };
  },
  methods: {
    openModal() {
      this.showModal = true;
    },
    closeModal() {
      this.showModal = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.footer {
  margin-top: 1rem;

  .footer-wrapper {
    background-color: $gray;
    padding: 0.625rem 0.625rem 1.25rem;    
  }

  ul {
    text-align: center;
    li {
      padding: 0.9375rem 0;
    }
    a,
    button {
      font-size: 0.875rem;
      background-color: transparent;
      color: $main;
      &:hover {
        opacity: 0.8;
      }
    }
  }

  .footer-hint {
    text-align: center;
    padding: 1rem;
    font-size: 12px;
  }

  .contact-modal {
    h4 {
      margin-bottom: 0.3125rem;
      font-size: 0.875rem;
      font-weight: 700;
    }
    &__content {
      p {
        font-size: 0.875rem;
        line-height: 1.4285rem;
      }
      form {
        margin: 0.9375rem 0;
        label {
          font-size: 0.875rem;
          font-weight: 700;
        }
        textarea {
          width: 100%;
          height: 10rem;
          padding: 0.3125rem;
          border: 0.0625rem solid #e3e3e3;
          font-size: 0.875rem;
        }
        button {
          margin-top: 0.9375rem;
        }
      }
    }
  }
  @include breakpoint(tablet) {
    padding: 0;
    ul {
      display: flex;
      justify-content: center;
      li {
        margin: 0.9375rem;
        padding: 0.3125rem 0;
      }
    }
  }
  @include breakpoint(desktop) {
    padding: 0;
    margin-top: 6rem;
    ul {
      li {
        margin: 0.9375rem;
      }
    }
  }
}
</style>
